import React from 'react';
import c from 'classnames';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import {
  APP_OPTIONS,
  SEARCHKIT_HOST_URL,
} from '../../config/constants';
import {
  facetAttributes,
  highlightAttributes,
  requestOptions,
  resultAttributes,
  searchAttributes,
  sorting,
} from './config';

// Subcomponents.
import ActiveFacets from './ActiveFacets';
import AdvancedFacets from './AdvancedFacets';
import Facets from './Facets';
import Pagination from '../SearchGeneral/Pagination';
import Results from './Results';
import SearchBar from './SearchBar';
import SortBy from './SortBy';
import Stats from '../SearchGeneral/Stats';
import TypeFacet from './TypeFacet';

interface SearchAllContentSubcomponents {
  ActiveFacets: typeof ActiveFacets;
  AdvancedFacets: typeof AdvancedFacets;
  Facets: typeof Facets;
  Pagination: typeof Pagination;
  Results: typeof Results;
  SearchBar: typeof SearchBar;
  SortBy: typeof SortBy;
  Stats: typeof Stats;
  TypeFacet: typeof TypeFacet;
}

export type SearchAllContentProps = Omit<SearchkitWrapperProps, 'connection' | 'indexName' | 'searchSettings'>;

// eslint-disable-next-line max-len
const SearchAllContent: React.FC<SearchAllContentProps> & SearchAllContentSubcomponents = (props) => {
  const {
    className,
    children,
    routing = true,
    ...restProps
  } = props;

  const classNames = c('SearchAllContent', className);

  return (
    <SearchkitWrapper
      {...restProps}
      className={classNames}
      connection={{ host: SEARCHKIT_HOST_URL }}
      indexName={APP_OPTIONS.parameters.searchkitIndexAllContent}
      routing={routing}
      initialUiState={{
        [APP_OPTIONS.parameters.searchkitIndexAllContent]: {
          sortBy: `${APP_OPTIONS.parameters.searchkitIndexAllContent}_bibcite_year`,
        },
      }}
      searchSettings={{
        search_attributes: searchAttributes,
        result_attributes: resultAttributes,
        facet_attributes: facetAttributes,
        highlight_attributes: highlightAttributes,
        sorting,
      }}
      requestOptions={requestOptions}
    >
      {children}
    </SearchkitWrapper>
  );
};

SearchAllContent.ActiveFacets = ActiveFacets;
SearchAllContent.AdvancedFacets = AdvancedFacets;
SearchAllContent.Facets = Facets;
SearchAllContent.Pagination = Pagination;
SearchAllContent.Results = Results;
SearchAllContent.SearchBar = SearchBar;
SearchAllContent.SortBy = SortBy;
SearchAllContent.Stats = Stats;
SearchAllContent.TypeFacet = TypeFacet;

export default SearchAllContent;
